/* @flow */

//----------------------------------------------------------------------//
// GLOBAL IMPORTS
//----------------------------------------------------------------------//

import * as React from 'react';
//----------------------------------------------------------------------//
// LOCAL IMPORTS
//----------------------------------------------------------------------//
import DetailsPanel from '../../../NotificationsReview/panels/DetailsPanel/DetailsPanel';

const ContractExtensionRequest = ({ data }) => {
  return (
    <React.Fragment>
      <DetailsPanel data={data} />
    </React.Fragment>
  );
};

export default ContractExtensionRequest;
